import { Component } from '@angular/core';

@Component({
  selector: 'cx-order-confirmation-page-layout',
  templateUrl: './order-confirmation-page-layout.component.html',
  styleUrls: ['./order-confirmation-page-layout.component.scss']
})
export class OrderConfirmationPageLayoutComponent {}
